const getters = {
  // Have to do some magic coz <3 IE
  pagesArray: ({ pages }) => Object.keys(pages).map(key => pages[key]),

  getById: ({ pages }) => (id) => {
    return pages[id]
  },

  byKey: ({ pages }) => key => pages[key],

  active: ({ active }) => active,

  newPage: ({ newPage }) => newPage,

  currentPage: ({ currentPage }) => currentPage,

  totalPageCount: ({ totalPageCount }) => totalPageCount,

  perPage: ({ perPage }) => perPage,

  revisions: ({ revisions }) => revisions,

  cardCollapsed: ({ cardCollapsed }) => (key) => {
    return cardCollapsed[key]
  }
}

export default getters
